var pe2 = "/static/4b7721b22f25d60f.png";

export { pe2 as default };
//# sourceMappingURL=pe_2.png.js.map
